import React from 'react'
import { RelatedTransaction } from '@finance-lab/utils/types'
import Box from '@mui/material/Box'
import { getUrlForType } from '../../utils/getUrlForEntity'
import IssueTypeLabels, { HasWarrantLabel } from './IssueTypeLabels'
import { ConvertibleTypeLabels } from './ConvertibleLabel'

export const PressReleaseRelatedTransactionsTags = ({
    relatedTransactions,
}: {
    relatedTransactions: RelatedTransaction[]
}) => {
    const uniqueTransactions = relatedTransactions.reduce((acc: RelatedTransaction[], t: RelatedTransaction) => {
        if (acc.find((t2) => t2.entityType === t.entityType)) {
            return acc
        }
        return [...acc, t]
    }, [])

    return (
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
            {uniqueTransactions
                .map((t) => ({ ...t, url: getUrlForType(t) }))
                .map((t) => {
                    if (t.entityType === 'Issue') {
                        return <IssueTypeLabels key={t.id} isSingleLabel issue={{ ...t, type: t.issueType }} />
                    }
                    if (t.entityType === 'Convertible') {
                        return <ConvertibleTypeLabels key={t.id} convertible={t} />
                    }
                    if (t.entityType === 'Warrant') {
                        return <HasWarrantLabel key={t.id} warrant={t} />
                    }
                })}
        </Box>
    )
}
